import { useLanguage } from "../context/LanguageContext";
import { Globe } from "lucide-react";
import { Button } from "./ui/button";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "./ui/dropdown-menu";

const LanguageSwitcher = ({ variant = "ghost", size = "icon" }) => {
    const { language, setLanguage } = useLanguage();

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant={variant} size={size} className="gap-2" data-testid="language-switcher">
                    <Globe className="w-4 h-4" />
                    <span className="hidden sm:inline uppercase">{language}</span>
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
                <DropdownMenuItem 
                    onClick={() => setLanguage('en')}
                    className={language === 'en' ? 'bg-accent' : ''}
                    data-testid="lang-en"
                >
                    <span className="mr-2">🇺🇸</span>
                    English
                </DropdownMenuItem>
                <DropdownMenuItem 
                    onClick={() => setLanguage('id')}
                    className={language === 'id' ? 'bg-accent' : ''}
                    data-testid="lang-id"
                >
                    <span className="mr-2">🇮🇩</span>
                    Indonesia
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
};

export default LanguageSwitcher;
